// ExpenseDocumentSummary.js
import React from "react";
import { Box, Paper, Typography } from "@mui/material";

const Row = ({ label, value }) => (
  <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
    <Typography>{label}</Typography>
    <Typography fontWeight={600}>{value} €</Typography>
  </Box>
);

const ExpenseDocumentSummary = ({ summary }) => {
  return (
    <Paper sx={{ p: 2, mb: 3, maxWidth: 400 }}>
      <Typography variant="subtitle1" gutterBottom>
        Resumen
      </Typography>

      <Row label="Anticipos" value={summary.totalAdvances.toFixed(2)} />
      <Row label="Gastos" value={summary.totalExpenses.toFixed(2)} />
      <Row label="Balance" value={summary.difference.toFixed(2)} />
    </Paper>
  );
};

export default ExpenseDocumentSummary;
